import { MediaType } from '@/types';

import type { ContentFile } from '@/types';

const isVideoContentFile = (file: ContentFile): boolean =>
  file.type === MediaType.VIDEO;

export default isVideoContentFile;
